<template>
  <div>
    <Calendar v-model="events" />
  </div>
</template>

<script>
import Calendar from "@/components/Calendar";

export default {
  name: "MyCalendarIndex",
  components: {
    Calendar
  },
  props: {},
  computed: {},
  data() {
    return {
      events: [
        {
          from: "2021-02-26T18:00:00Z",
          to: "2021-02-26T19:00:00Z",
          data: "Event 1"
        },
        {
          from: "2021-02-26T19:00:00Z",
          to: "2021-02-26T21:00:00Z",
          data: "Olive & Friends"
        }
      ]
    };
  },
  methods: {},
  created() {
    // when appointment information is provided
    //    go to event
    // else
    //    go to today
  }
};
</script>

<style></style>
